import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const StackoverflowScaleSmall = hoc(
    (props: IconProps) => (
        <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M12.4781 13.9149V11.4605L14.4001 11.3997V15.3997L1.6001 15.3997L1.6001 11.3997H3.56539L3.56539 13.8541L12.4781 13.9149Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.5675 1L9.47644 1.80865L13.5241 7.25862L14.6152 6.4519L10.5675 1ZM12.4155 8.55947L7.18909 4.21718H7.19001L8.05216 3.17969L13.2777 7.52197L12.4155 8.55947ZM5.4823 7.24123L11.6411 10.1066L12.2041 8.87584L6.04538 5.99316L5.4823 7.24123ZM4.60266 10.4059L11.2543 11.7943L11.5359 10.4578L4.8842 9.06934L4.60266 10.4059ZM10.9229 13.4997L4.46143 13.4997V12.1458L10.9229 12.1458V13.4997Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </svg>
    ),
    'Stackoverflow'
);
export default StackoverflowScaleSmall;
